var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuyNowPayLater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40,
    cy: 63.5,
    rx: 40,
    ry: 14.5,
    fill: "#E5E5E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.0269 0.353339C45.5247 0.0920969 46.0844 -0.0281615 46.6457 0.00555422C47.2069 0.03927 47.7482 0.225677 48.2112 0.544642C50.8154 2.04422 52.9321 6.39486 52.9321 10.2333V19.2863C52.9392 19.3444 52.9339 19.4034 52.9166 19.4593C52.8992 19.5152 52.8702 19.5668 52.8314 19.6107C52.7926 19.6546 52.7449 19.6897 52.6915 19.7137C52.6381 19.7378 52.5802 19.7502 52.5217 19.7502C52.4631 19.7502 52.4052 19.7378 52.3519 19.7137C52.2985 19.6897 52.2508 19.6546 52.212 19.6107C52.1732 19.5668 52.1442 19.5152 52.1268 19.4593C52.1094 19.4034 52.1042 19.3444 52.1113 19.2863V10.2271C52.1113 6.64788 50.1736 2.62431 47.7915 1.24815C47.4529 1.00534 47.0546 0.859252 46.6394 0.825551C46.2241 0.79185 45.8075 0.871806 45.4342 1.05685C44.453 1.62459 43.8914 3.06863 43.8914 5.01253V14.0224C43.8914 14.132 43.8478 14.2372 43.7703 14.3147C43.6927 14.3923 43.5876 14.4358 43.4779 14.4358C43.3682 14.4358 43.2631 14.3923 43.1855 14.3147C43.108 14.2372 43.0645 14.132 43.0645 14.0224V5.01253C43.0706 2.82179 43.7865 1.0877 45.0269 0.353339Z",
    fill: "#37474F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8042 52.2833L27.3405 8.7584L34.5978 4.58057L36.9798 45.2544L24.8042 52.2833Z",
    fill: "url(#paint0_linear_803_9345)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M24.8042 52.2833L27.3405 8.7584L34.5978 4.58057L36.9798 45.2544L24.8042 52.2833Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M24.8042 52.2833L27.3405 8.7584L34.5978 4.58057L36.9798 45.2544L24.8042 52.2833Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0972 19.3048L62.4792 59.9787L36.9802 45.2544L34.5981 4.58057L60.0972 19.3048Z",
    fill: "url(#paint1_linear_803_9345)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M60.0972 19.3048L62.4792 59.9787L36.9802 45.2544L34.5981 4.58057L60.0972 19.3048Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M60.0972 19.3048L62.4792 59.9787L36.9802 45.2544L34.5981 4.58057L60.0972 19.3048Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0968 19.3047L52.8396 23.4825L50.3032 67.0074L62.4788 59.9785L60.0968 19.3047Z",
    fill: "url(#paint2_linear_803_9345)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M60.0968 19.3047L52.8396 23.4825L50.3032 67.0074L62.4788 59.9785L60.0968 19.3047Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M50.3032 67.0075L55.5363 59.6577L56.1905 34.0044L56.8446 59.2134L62.4788 59.9786L50.3032 67.0075Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8042 52.2832L50.3033 67.0014L52.8396 23.4765L27.3405 8.7522L24.8042 52.2832ZM44.3358 22.9273C44.3358 22.3101 44.7431 22.1003 45.2491 22.3904C45.5133 22.5645 45.7329 22.7981 45.8905 23.0724C46.048 23.3468 46.139 23.6543 46.1563 23.9702C46.1563 24.5503 45.749 24.7909 45.2491 24.5009C44.9822 24.3307 44.76 24.0989 44.6011 23.8251C44.4422 23.5513 44.3512 23.2434 44.3358 22.9273ZM35.3013 17.6695C35.3013 17.0832 35.7086 16.8425 36.2084 17.1326C36.4748 17.3049 36.6964 17.538 36.8552 17.8126C37.0139 18.0872 37.1053 18.3956 37.1218 18.7124C37.1218 19.2925 36.7145 19.527 36.2084 19.2431C35.9437 19.071 35.7235 18.8388 35.5659 18.5652C35.4082 18.2917 35.3175 17.9847 35.3013 17.6695V17.6695Z",
    fill: "url(#paint3_linear_803_9345)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M24.8042 52.2832L50.3033 67.0014L52.8396 23.4765L27.3405 8.7522L24.8042 52.2832ZM44.3358 22.9273C44.3358 22.3101 44.7431 22.1003 45.2491 22.3904C45.5133 22.5645 45.7329 22.7981 45.8905 23.0724C46.048 23.3468 46.139 23.6543 46.1563 23.9702C46.1563 24.5503 45.749 24.7909 45.2491 24.5009C44.9822 24.3307 44.76 24.0989 44.6011 23.8251C44.4422 23.5513 44.3512 23.2434 44.3358 22.9273ZM35.3013 17.6695C35.3013 17.0832 35.7086 16.8425 36.2084 17.1326C36.4748 17.3049 36.6964 17.538 36.8552 17.8126C37.0139 18.0872 37.1053 18.3956 37.1218 18.7124C37.1218 19.2925 36.7145 19.527 36.2084 19.2431C35.9437 19.071 35.7235 18.8388 35.5659 18.5652C35.4082 18.2917 35.3175 17.9847 35.3013 17.6695V17.6695Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7577 4.51287C38.2542 4.25194 38.8125 4.13129 39.3724 4.16391C39.9324 4.19653 40.4729 4.38117 40.9358 4.69799C43.54 6.20374 45.6628 10.5544 45.6628 14.3928V23.4458C45.6628 23.5555 45.6193 23.6607 45.5418 23.7382C45.4642 23.8158 45.359 23.8593 45.2494 23.8593C45.1397 23.8593 45.0346 23.8158 44.957 23.7382C44.8795 23.6607 44.8359 23.5555 44.8359 23.4458V14.3928C44.8359 10.8136 42.9044 6.78383 40.5161 5.41384C40.1776 5.17103 39.7793 5.02495 39.364 4.99125C38.9487 4.95755 38.5321 5.0375 38.1588 5.22254C37.1776 5.79028 36.616 7.22815 36.616 9.17205V18.1881C36.616 18.2977 36.5724 18.4029 36.4949 18.4804C36.4174 18.558 36.3122 18.6015 36.2025 18.6015C36.0929 18.6015 35.9877 18.558 35.9102 18.4804C35.8326 18.4029 35.7891 18.2977 35.7891 18.1881V9.17205C35.7952 6.92576 36.5111 5.22872 37.7577 4.51287Z",
    fill: "#455A64"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6498 15.9662C24.0843 15.7396 24.5723 15.6354 25.0614 15.6648C25.5506 15.6941 26.0225 15.8559 26.4268 16.1328C28.6978 17.4411 30.5491 21.2363 30.5491 24.5872V32.4924C30.5491 32.5873 30.5114 32.6784 30.4443 32.7455C30.3772 32.8126 30.2861 32.8503 30.1912 32.8503C30.0963 32.8503 30.0052 32.8126 29.9381 32.7455C29.871 32.6784 29.8333 32.5873 29.8333 32.4924V24.5872C29.8333 21.4646 28.1424 17.9533 26.0689 16.7499C25.7726 16.5379 25.4239 16.4109 25.0607 16.3826C24.6974 16.3543 24.3333 16.4258 24.0078 16.5894C23.1561 17.0831 22.6625 18.3359 22.6625 20.0329V27.9011C22.6625 27.996 22.6247 28.0871 22.5576 28.1542C22.4905 28.2213 22.3995 28.259 22.3045 28.259C22.209 28.259 22.1173 28.2215 22.0492 28.1546C21.9811 28.0876 21.942 27.9966 21.9404 27.9011V20.0329C21.9404 18.0767 22.5637 16.5894 23.6498 15.9662Z",
    fill: "#37474F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M6 61.2683L8.20926 23.2851L14.547 19.6379L16.6267 55.1342L6 61.2683Z",
    fill: "url(#paint4_linear_803_9345)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M6 61.2683L8.20926 23.2851L14.547 19.6379L16.6267 55.1342L6 61.2683Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8066 32.4924L38.8801 67.9886L16.627 55.1342L14.5474 19.6379L36.8066 32.4924Z",
    fill: "url(#paint5_linear_803_9345)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M36.8066 32.4924L38.8801 67.9886L16.627 55.1342L14.5474 19.6379L36.8066 32.4924Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8061 32.4927L30.4684 36.1398L28.2529 74.123L38.8796 67.9889L36.8061 32.4927Z",
    fill: "url(#paint6_linear_803_9345)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M36.8061 32.4927L30.4684 36.1398L28.2529 74.123L38.8796 67.9889L36.8061 32.4927Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M28.2529 74.1229L32.8257 67.7111L33.3935 45.3223L33.9612 67.3223L38.8796 67.9888L28.2529 74.1229Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M6 61.2687L28.2531 74.117L30.4685 36.1461L8.20926 23.2979L6 61.2687ZM23.0446 35.6463C23.0446 35.1402 23.4025 34.9304 23.8407 35.1834C24.0721 35.3342 24.2648 35.5373 24.4031 35.7764C24.5414 36.0155 24.6215 36.2838 24.6368 36.5596C24.6368 37.0656 24.2788 37.2754 23.8407 37.0286C23.6084 36.8772 23.4153 36.6731 23.2769 36.4329C23.1386 36.1926 23.059 35.9231 23.0446 35.6463V35.6463ZM15.1579 31.0611C15.1579 30.5489 15.5159 30.3391 15.954 30.5921C16.1854 30.7429 16.3781 30.946 16.5164 31.1851C16.6547 31.4242 16.7348 31.6925 16.7501 31.9683C16.7501 32.4743 16.3922 32.6841 15.954 32.4373C15.7222 32.2869 15.5293 32.0838 15.391 31.8447C15.2526 31.6055 15.1728 31.337 15.1579 31.0611V31.0611Z",
    fill: "url(#paint7_linear_803_9345)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3302 19.5766C17.764 19.3513 18.2507 19.2478 18.7387 19.2771C19.2266 19.3064 19.6974 19.4675 20.1011 19.7433C22.3782 21.0577 24.2234 24.8529 24.2234 28.2039V36.1029C24.2234 36.1978 24.1857 36.2889 24.1185 36.356C24.0514 36.4231 23.9604 36.4608 23.8654 36.4608C23.7705 36.4608 23.6795 36.4231 23.6123 36.356C23.5452 36.2889 23.5075 36.1978 23.5075 36.1029V28.2039C23.5075 25.0813 21.8166 21.5637 19.7431 20.3665C19.4483 20.1541 19.1011 20.0263 18.7389 19.9969C18.3767 19.9675 18.0133 20.0377 17.6881 20.1999C16.8304 20.6936 16.3367 21.9525 16.3367 23.6496V31.5116C16.3367 31.6065 16.299 31.6975 16.2318 31.7647C16.1647 31.8318 16.0737 31.8695 15.9787 31.8695C15.8838 31.8695 15.7928 31.8318 15.7257 31.7647C15.6585 31.6975 15.6208 31.6065 15.6208 31.5116V23.6496C15.5961 21.6872 16.2194 20.2061 17.3302 19.5766Z",
    fill: "#455A64"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9383 64.462L56.2504 67.7554C56.1916 67.857 56.1539 67.9694 56.1395 68.0858C56.125 68.2023 56.1342 68.3205 56.1664 68.4333C56.1986 68.5461 56.2532 68.6513 56.327 68.7426C56.4007 68.8339 56.4921 68.9094 56.5957 68.9646C56.6992 69.0198 56.8128 69.0536 56.9297 69.0639C57.0466 69.0743 57.1644 69.061 57.2761 69.0248C57.3877 68.9887 57.4909 68.9304 57.5796 68.8535C57.6682 68.7766 57.7404 68.6826 57.792 68.5772L59.4903 65.2655C59.6549 64.948 59.4406 64.5104 59.0108 64.2896C58.581 64.0688 58.1016 64.1446 57.9383 64.462Z",
    fill: "#C2AF03"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1258 57.568L74.4192 59.2558C74.6227 59.3553 74.8569 59.3719 75.0723 59.3021C75.2878 59.2323 75.4677 59.0816 75.5743 58.8817C75.6808 58.6819 75.7056 58.4485 75.6434 58.2307C75.5813 58.0129 75.437 57.8278 75.241 57.7143L71.9293 56.016C71.6118 55.8514 71.1742 56.0669 70.9521 56.4954C70.73 56.9239 70.8084 57.4047 71.1258 57.568Z",
    fill: "#C2AF03"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9713 42.9589L73.9556 42.9511L68.005 39.8981L67.9828 39.8876C66.2231 38.9967 63.8716 39.2579 61.3398 40.8883C56.2541 44.1634 52.3689 51.717 52.6615 57.759C52.8078 60.7715 53.9679 62.8382 55.7184 63.7488L55.7341 63.7566L61.6873 66.8097L61.7056 66.8188C63.4666 67.7137 65.8194 67.4524 68.3538 65.8207C73.4396 62.5443 77.3248 54.9921 77.0309 48.9487C76.8819 45.9375 75.7258 43.8708 73.9713 42.9589Z",
    fill: "#F7E21E"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M61.5541 66.7389L55.738 63.7538L55.7211 63.7434C53.9692 62.8289 52.8117 60.7622 52.6654 57.7549C52.5348 55.0598 53.2363 52.0669 54.5022 49.2869L60.441 52.3412C59.1778 55.1212 58.4815 58.1141 58.6121 60.8092C58.7532 63.7564 59.8636 65.7983 61.5541 66.7389Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M74.7073 58.424C78.0963 51.8354 77.7598 44.9081 73.9557 42.9514C70.1517 40.9947 64.3206 44.7496 60.9317 51.3382C57.5427 57.9267 57.8792 64.854 61.6832 66.8107C65.4872 68.7674 71.3183 65.0125 74.7073 58.424Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0883 65.3987C61.0836 65.545 60.6029 62.1732 60.531 60.7166C60.2698 55.3878 63.844 48.4444 68.3289 45.5625C69.4707 44.827 70.585 44.4142 71.5504 44.3672C74.5551 44.2208 75.0372 47.5926 75.1077 49.0493C75.369 54.378 71.796 61.3215 67.3099 64.2099C66.1681 64.9454 65.0538 65.3582 64.0896 65.4052L64.0883 65.3987Z",
    fill: "#FAFAFA"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5668 61.9199C66.5513 61.9202 66.5359 61.918 66.5211 61.9133C66.4863 61.903 66.457 61.8794 66.4396 61.8476C66.4223 61.8157 66.4182 61.7783 66.4283 61.7435L68.2377 55.6453C68.2427 55.6281 68.2511 55.6121 68.2623 55.5982C68.2736 55.5843 68.2875 55.5727 68.3032 55.5642C68.3189 55.5556 68.3361 55.5503 68.3539 55.5484C68.3717 55.5465 68.3897 55.5481 68.4068 55.5532C68.424 55.5582 68.44 55.5666 68.4539 55.5779C68.4678 55.5891 68.4794 55.603 68.4879 55.6187C68.4965 55.6344 68.5018 55.6516 68.5037 55.6694C68.5056 55.6872 68.504 55.7052 68.4989 55.7224L66.6922 61.8206C66.6838 61.8479 66.6673 61.872 66.6449 61.8897C66.6225 61.9074 66.5953 61.9179 66.5668 61.9199V61.9199Z",
    fill: "url(#paint8_linear_803_9345)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6759 54.0226C71.6465 54.071 71.6073 54.1128 71.5609 54.1454L68.5405 56.2761L63.6677 53.2975C63.6216 53.2693 63.5814 53.2323 63.5496 53.1885C63.5178 53.1448 63.4949 53.0952 63.4822 53.0426C63.4695 52.99 63.4673 52.9355 63.4757 52.882C63.4841 52.8286 63.503 52.7773 63.5312 52.7312C63.5594 52.685 63.5965 52.6449 63.6402 52.6131C63.6839 52.5812 63.7335 52.5583 63.7861 52.5457C63.8387 52.533 63.8932 52.5308 63.9467 52.5392C64.0001 52.5476 64.0514 52.5665 64.0975 52.5947L68.504 55.2885L71.0893 53.4673C71.1669 53.4132 71.2608 53.3874 71.3552 53.3942C71.4496 53.401 71.5388 53.4401 71.6079 53.5048C71.6769 53.5696 71.7216 53.6561 71.7345 53.7499C71.7473 53.8437 71.7276 53.939 71.6785 54.0199L71.6759 54.0226Z",
    fill: "#37474F"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3038 54.3569C68.9021 53.9716 69.4155 54.2355 69.4508 54.9461C69.4861 55.6568 69.0275 56.5451 68.4292 56.9305C67.8309 57.3159 67.3175 57.052 67.2835 56.3414C67.2496 55.6307 67.7055 54.7423 68.3038 54.3569Z",
    fill: "#C2AF03"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_803_9345",
    x1: 30.892,
    y1: 4.58057,
    x2: 30.892,
    y2: 52.2833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4568DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B06AB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_803_9345",
    x1: 48.5387,
    y1: 4.58057,
    x2: 48.5387,
    y2: 59.9787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4568DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B06AB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_803_9345",
    x1: 56.391,
    y1: 19.3047,
    x2: 56.391,
    y2: 67.0074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4568DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B06AB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_803_9345",
    x1: 38.8219,
    y1: 8.7522,
    x2: 38.8219,
    y2: 67.0014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4568DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B06AB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_803_9345",
    x1: 11.3133,
    y1: 19.6379,
    x2: 11.3133,
    y2: 61.2683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4568DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B06AB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_803_9345",
    x1: 26.7137,
    y1: 19.6379,
    x2: 26.7137,
    y2: 67.9886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4568DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B06AB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_803_9345",
    x1: 33.5663,
    y1: 32.4927,
    x2: 33.5663,
    y2: 74.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4568DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B06AB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_803_9345",
    x1: 18.2342,
    y1: 23.2979,
    x2: 18.2342,
    y2: 74.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4568DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B06AB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_803_9345",
    x1: 67.4637,
    y1: 55.5476,
    x2: 67.4637,
    y2: 61.9199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4568DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B06AB3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyNowPayLater);
export default __webpack_public_path__ + "static/media/buyNowPayLater.9031ddd7dbd6859b995f0b0e05ad05a9.svg";
export { ForwardRef as ReactComponent };